import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { Map } from 'immutable'
import * as ROUTE from 'constants/appRouting'
import TranslationsLayout from './TranslationsLayout'
import JobWorkflow from './JobWorkflow'
import JobWorkflowTask from './JobWorkflowTask'
import JobWorkflowInput from './JobWorkflowInput'
import LogbookEvent from './LogbookEvent'
import LogbookEventCategory from './LogbookEventCategory'
import LogbookForm from './LogbookForm'
import MonitoringAlerts from './MonitoringAlerts'
import SensorType from './SensorType'

const items = {
  data: [
    {
      path: ROUTE.TRANSLATIONS_JOB_WORKFLOW_TABLE_LIST,
      alt: 'Job Workflow',
      name: 'job',
    },
    {
      path: ROUTE.TRANSLATIONS_JOB_WORKFLOW_TASK_TABLE_LIST,
      alt: 'Job Workflow Task',
      name: 'job_task',
    },
    {
      path: ROUTE.TRANSLATIONS_JOB_WORKFLOW_INPUT_TABLE_LIST,
      alt: 'Job Workflow Input',
      name: 'job_input',
    },
    {
      path: ROUTE.TRANSLATIONS_LOGBOOK_EVENT_TABLE_LIST,
      alt: 'Logbook Event',
      name: 'logbook_event',
    },
    {
      path: ROUTE.TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_TABLE_LIST,
      alt: 'Logbook Event Category',
      name: 'logbook_event_category',
    },
    {
      path: ROUTE.TRANSLATIONS_LOGBOOK_FORM_TABLE_LIST,
      alt: 'Logbook Form',
      name: 'logbook_form',
    },
    {
      path: ROUTE.TRANSLATIONS_MONITORING_ALERTS_TABLE_LIST,
      alt: 'Monitoring Alerts',
      name: 'monitoring_alerts',
    },
    {
      path: ROUTE.TRANSLATIONS_SENSOR_TYPE_TABLE_LIST,
      alt: 'Sensor Type',
      name: 'sensor_type',
    },
  ],
  count: 8,
}

function Translations(props) {
  return (
    <Switch>
      <Route
        path={ROUTE.TRANSLATIONS_JOB_WORKFLOW_EDIT_PARENT}
        component={JobWorkflow}
      />
      <Route
        path={ROUTE.TRANSLATIONS_JOB_WORKFLOW_TASK_EDIT_PARENT}
        component={JobWorkflowTask}
      />
      <Route
        path={ROUTE.TRANSLATIONS_JOB_WORKFLOW_INPUT_EDIT_PARENT}
        component={JobWorkflowInput}
      />
      <Route
        path={ROUTE.TRANSLATIONS_LOGBOOK_EVENT_EDIT_PARENT}
        component={LogbookEvent}
      />
      <Route
        path={ROUTE.TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_EDIT_PARENT}
        component={LogbookEventCategory}
      />
      <Route
        path={ROUTE.TRANSLATIONS_LOGBOOK_FORM_EDIT_PARENT}
        component={LogbookForm}
      />
      <Route
        path={ROUTE.TRANSLATIONS_MONITORING_ALERTS_EDIT_PARENT}
        component={MonitoringAlerts}
      />
      <Route
        path={ROUTE.TRANSLATIONS_SENSOR_TYPE_EDIT_PARENT}
        component={SensorType}
      />
      <Route
        path={ROUTE.TRANSLATIONS}
        component={() => (
          <TranslationsLayout tableData={new Map(items)} {...props} />
        )}
      />
    </Switch>
  )
}

export default withRouter(Translations)
